import styled from 'styled-components';
import { getThemeProps } from 'ravenjs/utils/theme';

const SubNavItemsStyled = styled.ul`
    align-items: stretch;
    display: flex;
    flex-grow: 1;
    height: 100%;
    justify-content: flex-start;
    list-style: none;
    margin: 0;
    padding: 0;
    /**
     * Add all of the remaining styles from theme
     */
    ${getThemeProps('SubNavItems.styles')};
`;

export default SubNavItemsStyled;
